import { trackEvent } from '@patrianna/analytics'
import type { TargetBanner } from '@patrianna/shared-patrianna-types/store/BannersModule'
import type { BannerInfo } from '@patrianna/shared-store/banners/store/types'
import { nextTick } from '@patrianna/shared-utils'

import BannerTile from 'components/BannerTile'
import { ImagesDirectory, generateImageUrl } from 'src/utils/setImageUrl'

type Props = {
  banners: (TargetBanner | BannerInfo)[]
}

export default function TargetBanners({ banners }: Props) {
  const onClickHandler = (category: string) => {
    nextTick().then(() => trackEvent('clicked_on_banner', { category }))
  }

  return (
    <>
      {banners.map((i) => {
        const { bannerImageUrl, title, code, ctaUrl } = i
        const bannerUrl = generateImageUrl(bannerImageUrl, ImagesDirectory.BANNERS)

        return (
          <BannerTile
            url={ctaUrl}
            onClick={() => onClickHandler(`target-banner-${code}`)}
            src={bannerUrl}
            alt={title}
            key={code}
            dataTest={`target-banner-${code}`}
          />
        )
      })}
    </>
  )
}
